import React from "react";
import "./App.scss";
import './i18n';
import Grid from "./container/Grid/Grid";

const App = () => {
  return (
    <div className="app">
      <Grid/>
    </div>
  );
};

export default App;
